import script from "./VTableCode.vue?vue&type=script&setup=true&lang=js"
export * from "./VTableCode.vue?vue&type=script&setup=true&lang=js"

import "./VTableCode.vue?vue&type=style&index=0&id=208ee084&scoped=true&lang=less"

import exportComponent from "D:\\cwzl\\four-cw-net\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-208ee084"]])

export default __exports__